

























import { Vue } from "vue-property-decorator"
import type { stadium_base, stadium_curator, stadium_ground_price } from "@/@types/stadium/stadium"
import Base from "@/views/invest/detail/form/stadium_base.vue"
import Curator from "@/views/invest/detail/form/stadium_curator.vue"
import Notice from "@/views/invest/detail/form/stadium_notice.vue"
import StadiumTags from "@/views/invest/detail/form/stadium_tags.vue"
import StadiumGrounds from "@/views/invest/detail/form/stadium_grounds.vue"
import StadiumGroundPrice from "@/views/invest/detail/form/stadium_ground_price.vue"
import BusinessNewDay from "@/views/invest/detail/form/business_new_day.vue"
import Correct from "@/views/invest/detail/form/correct.vue"

export default Vue.extend({
  name: "StadiumBusinessInfo",
  components: {
    Base,
    Curator,
    Notice,
    StadiumTags,
    StadiumGrounds,
    StadiumGroundPrice,
    BusinessNewDay,
    Correct
  },
  props: {
    id: { type: String, default: "" },
  },
  data() {
    return {
      stadium: {
        id             : "",
        stadium_id     : "",
        name           : "",
        status         : "",
        status_logs    : [],
        estimate_logs  : [],
        business_status: "0",
        cooperate_info : {
          stadium_notice   : "",
          business_days_new: [],
          stadium_tags     : []
        }
      } as any,
      record : {} as any,
      correct: {} as any,
      /* 评估状态 */
      business_status: [
        { value: 0, label: "未开始", icon: "clock-circle", status: "#f60" },
        { value: 1, label: "审核中", icon: "clock-circle", status: "#10aeff" },
        { value: 2, label: "已通过", icon: "check-circle", status: "#4cd964" },
        { value: 3, label: "未通过", icon: "close-circle", status: "#f6383a" },
        { value: 4, label: "已撤销", icon: "clock-circle", status: "default" }
      ],
      editable            : false,
      stadium_base        : {} as stadium_base,
      stadium_curator     : {} as stadium_curator,
      stadium_ground_price: {} as stadium_ground_price,
    }
  },
  methods: {
    async get_info() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        if (!data.cooperate_info.business_days_new) data.cooperate_info.business_days_new = []
        if (data.business_status == "2") {
          const correct = await this.$store.dispatch("invest_correct/info", { estimate_id: this.id, op: 2 });
          if (correct.Code == 200) {
            const correct_data = correct.Data
            if (correct_data.status < 2) {
              this.record  = correct_data
              this.correct = correct_data
            }
          }
        }
        this.stadium = data
        this.handleStadiumBase(data.cooperate_info)
        this.handleStadiumCurator(data.cooperate_info)
        this.handleStadiumTags()
        this.handleStadiumGround()
        this.handleStadiumGroundPrice(data.cooperate_info)
        this.handleBusinessNewDays()
      }
    },
    /* 处理场馆基本信息 */
    handleStadiumBase(data: any) {
      this.stadium_base = {
        name         : data.name,
        province_id  : data.province_id,
        city_id      : data.city_id,
        county_id    : data.county_id,
        area_name    : data.area_name,
        addr         : data.addr,
        contact      : data.contact,
        sex          : data.sex,
        contact_phone: data.contact_phone,
        phone        : data.phone,
        longitude    : data.longitude,
        latitude     : data.latitude,
      }
      const base = this.$refs.base as any
      base.init()
    },
    handleStadiumCurator(data: any) {
      this.stadium_curator = {
        manager_nick  : data.manager_nick,
        manager_avatar: data.manager_avatar,
      }
    },
    handleStadiumTags() {
      const stadium_tags = this.$refs.stadium_tags as any
      stadium_tags.init()
    },
    handleStadiumGround() {
      const stadium_grounds = this.$refs.stadium_grounds as any
      stadium_grounds.init()
    },
    handleStadiumGroundPrice(data: any) {
      this.stadium_ground_price = {
        is_half_time     : data.is_half_time,
        is_people_bill   : data.is_people_bill,
        business_time    : data.business_time,
        business_time_new: data.business_time_new,
      }
      const ground_price = this.$refs.ground_price as any
      ground_price.init()
    },
    handleBusinessNewDays() {
      const new_day = this.$refs.business_new_day as any
      new_day.init()
    },
    start_correct() {
      if (this.record && this.record.status == 1) {
        this.$info({ content: "纠错审核中，暂无法纠错" })
      } else {
        this.$confirm({
          content: "确定进行纠错？",
          onOk   : () => { this.editable = true }
        })
      }
    },
    async save(params: any) {
      const res = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code == 200) {
        this.$success({
          content: "保存成功",
        })
      } else {
        this.$error({
          content: res.Message,
        })
      }
    },
    modify(params: any) {
      const origin = this.$deep_copy(this.stadium.cooperate_info)
      for (const key in origin) {
        if (key != "business_time_hour" && key != "business_time_new_hour") {
          if (Object.prototype.hasOwnProperty.call(origin, key) && Object.prototype.hasOwnProperty.call(params, key)) {
            let   flag    = false
            const compare = origin[key]
            const change  = params[key]
            if (change != compare) flag = true
            if (key == "business_time" || key == "business_time_new" || key == "grounds") {
              flag = false
              if (JSON.stringify(change) != JSON.stringify(compare)) flag = true
            }
            if (flag) this.correct[key] = change
            else delete this.correct[key]
          }
        } else delete this.correct[key]
      }
      if (Object.prototype.hasOwnProperty.call(params, "prices") && (Object.prototype.hasOwnProperty.call(this.correct, "prices") && this.correct["prices"].length > 0)) this.correct["prices"] = params["prices"]
      this.correct.estimate_id = this.id
      this.correct.op = 2
    },
    async submit() {
      this.editable = false
      const correct = this.$refs.correct as any
      correct.open(this.id, 2)
    },
    close() {
      return false
    }
  },
  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.get_info();
        })
      }
    }
  }
})

